if (!customElements.get('meet-your-legend-hero')) {
  customElements.define(
    'meet-your-legend-hero',
    class MeetYourLegendHero extends HTMLElement {
      connectedCallback() {
        if (this.classList.contains('is-visible')) return;

        const threshold = parseFloat(this.dataset.threshold || '0.2');
        const observer = new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {
              if (entry.isIntersecting) {
                this.classList.add('is-visible');
                observer.disconnect();
              }
            });
          },
          {
            threshold,
            rootMargin: '0px 0px -8% 0px',
          }
        );

        observer.observe(this);
      }
    }
  );
}
